import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const RequiredStarBox = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.brand.main};
`;
